module.exports = __webpack_public_path__ + "static/media/hootsuite-horizontal-black-registered.e0559b69.png";